import { Component, OnInit } from '@angular/core';
import { BrevoApiKeyDto, ConfiguratorTenantConfigurationService, DatastoreDto, Partner } from '@tj/tj-dmp-lib-api';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'dmp-brevo-config',
    templateUrl: './brevo-config.component.html',
    styleUrls: ['./brevo-config.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class BrevoConfigComponent implements OnInit {

    breadcrumb = [
        { label: 'Paramètres' },
        { label: 'Configuration Brevo' }
    ];
    description = 'Gérez les clés API Brevo par partenaire du groupe.';

    datastore: DatastoreDto;
    partner: Partner;

    apiKeyInput = '';
    apiKeyConfigured = false;
    loading = false;
    saving = false;

    constructor(
        private tenantConfigService: ConfiguratorTenantConfigurationService,
        private messageService: MessageService
    ) {}

    ngOnInit(): void {}

    onSelectionChange(event: { group: DatastoreDto; partner: Partner }) {
        this.datastore = event.group;
        this.partner = event.partner;
        this.apiKeyInput = '';
        this.apiKeyConfigured = false;

        if (this.datastore && this.partner) {
            this.loadBrevoKeyStatus();
        }
    }

    private loadBrevoKeyStatus() {
        this.loading = true;
        this.tenantConfigService
            .getPartnerBrevoKeyUsingGET(this.datastore.code, this.partner.code)
            .subscribe({
                next: (dto: BrevoApiKeyDto) => {
                    this.apiKeyConfigured = dto.apiKeyConfigured ?? false;
                    this.loading = false;
                },
                error: () => {
                    this.apiKeyConfigured = false;
                    this.loading = false;
                }
            });
    }

    save() {
        if (!this.datastore || !this.partner) {
            this.messageService.add({ severity: 'warn', summary: 'Attention', detail: 'Sélectionnez un groupe et un partenaire.' });
            return;
        }
        if (!this.apiKeyInput || !this.apiKeyInput.trim()) {
            this.messageService.add({ severity: 'warn', summary: 'Attention', detail: 'Veuillez saisir une clé API Brevo.' });
            return;
        }

        this.saving = true;
        const dto: BrevoApiKeyDto = { apiKey: this.apiKeyInput.trim() };

        this.tenantConfigService
            .savePartnerBrevoKeyUsingPUT(this.datastore.code, this.partner.code, dto)
            .subscribe({
                next: (result: BrevoApiKeyDto) => {
                    this.apiKeyConfigured = result.apiKeyConfigured ?? true;
                    this.apiKeyInput = '';
                    this.saving = false;
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Succès',
                        detail: `Clé API Brevo enregistrée pour le partenaire ${this.partner.code}.`
                    });
                },
                error: () => {
                    this.saving = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Impossible d\'enregistrer la clé API Brevo.'
                    });
                }
            });
    }
}
